import React, { useState, useMemo } from 'react';

const INVOICE_TYPES = [
  { id: 'tpy', name: 'ΤΠΥ - Τιμολόγιο Παροχής Υπηρεσιών', mydata: '2.1' },
  { id: 'apy', name: 'ΑΠΥ - Απόδειξη Παροχής Υπηρεσιών', mydata: '11.2' },
  { id: 'pis', name: 'Πιστωτικό Τιμολόγιο', mydata: '5.1' },
];

const PAYMENT_METHODS = [
  { id: 'bank', name: 'Τραπεζική Κατάθεση', icon: '🏦' },
  { id: 'cash', name: 'Μετρητά', icon: '💵' },
  { id: 'card', name: 'Κάρτα / POS', icon: '💳' },
  { id: 'check', name: 'Επιταγή', icon: '📝' },
];

const DOY_LIST = [
  "Α' Αθηνών","Β' Αθηνών","Γ' Αθηνών","Δ' Αθηνών","Α' Θεσσαλονίκης","Β' Θεσσαλονίκης",
  "Γ' Θεσσαλονίκης","Δ' Θεσσαλονίκης","Πειραιά","Α' Πατρών","Ηρακλείου","Λαρίσης",
  "Βόλου","Ιωαννίνων","Χανίων","Καβάλας","Ρόδου","Κέρκυρας","ΦΑΕ Αθηνών","ΦΑΕ Θεσσαλονίκης",
];

const calculateGrammatioAmount = (streitwert, type) => {
  if (type === 'agogi') {
    if (streitwert <= 6000) return 44;
    if (streitwert <= 20000) return 66;
    if (streitwert <= 65000) return 88;
    if (streitwert <= 250000) return 176;
    return 264;
  }
  if (type === 'parastasi') {
    if (streitwert <= 6000) return 33;
    if (streitwert <= 20000) return 50;
    if (streitwert <= 65000) return 66;
    return 132;
  }
  return 0;
};

const InvoiceCreator = ({ onClose, onSave }) => {
  const [invoiceType, setInvoiceType] = useState('tpy');
  const [series, setSeries] = useState('A');
  const [number, setNumber] = useState('003');
  const [issueDate, setIssueDate] = useState(new Date().toISOString().split('T')[0]);
  const [dueDate, setDueDate] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('bank');
  const [selectedClient, setSelectedClient] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientAfm, setClientAfm] = useState('');
  const [clientDoy, setClientDoy] = useState('');
  const [clientAddress, setClientAddress] = useState('');
  const [clientProfession, setClientProfession] = useState('');
  const [items, setItems] = useState([{ description: '', amount: 0, qty: 1 }]);
  const [withFPA, setWithFPA] = useState(true);
  const [fpaRate, setFpaRate] = useState(24);
  const [withParakratisi, setWithParakratisi] = useState(true);
  const [parakratisiRate, setParakratisiRate] = useState(15);
  const [withXartosimo, setWithXartosimo] = useState(false);
  const [xartosimoRate] = useState(1.2);
  const [withGrammatio, setWithGrammatio] = useState(false);
  const [grammatioType, setGrammatioType] = useState('agogi');
  const [streitwert, setStreitwert] = useState(0);
  const [notes, setNotes] = useState('');
  const [bankInfo, setBankInfo] = useState('IBAN: GR00 0000 0000 0000 0000 0000 000\nΤράπεζα: Εθνική Τράπεζα');
  const [sendMydata, setSendMydata] = useState(true);

  const calc = useMemo(() => {
    const subtotal = items.reduce((sum, item) => sum + (item.amount * item.qty), 0);
    const fpa = withFPA ? subtotal * (fpaRate / 100) : 0;
    const xartosimo = withXartosimo ? subtotal * (xartosimoRate / 100) : 0;
    const ogaXartosimo = withXartosimo ? xartosimo * 0.2 : 0;
    const total = subtotal + fpa + xartosimo + ogaXartosimo;
    const parakratisi = withParakratisi ? subtotal * (parakratisiRate / 100) : 0;
    const pliroteo = total - parakratisi;
    const grammatio = withGrammatio ? calculateGrammatioAmount(streitwert, grammatioType) : 0;
    return { subtotal, fpa, xartosimo, ogaXartosimo, total, parakratisi, pliroteo, grammatio };
  }, [items, withFPA, fpaRate, withParakratisi, parakratisiRate, withXartosimo, xartosimoRate, withGrammatio, streitwert, grammatioType]);

  const addItem = () => setItems(prev => [...prev, { description: '', amount: 0, qty: 1 }]);
  const removeItem = (i) => setItems(prev => prev.filter((_, idx) => idx !== i));
  const updateItem = (i, field, value) => setItems(prev => prev.map((item, idx) => idx === i ? { ...item, [field]: value } : item));

  const handleSelectClient = (name) => {
    setSelectedClient(name);
    if (name === 'Γεώργιος Παπαδόπουλος') {
      setClientName('Γεώργιος Παπαδόπουλος'); setClientAfm('123456789'); setClientDoy("Α' Αθηνών");
      setClientAddress('Σταδίου 10, 10562 Αθήνα'); setClientProfession('Επιχειρηματίας');
    } else if (name === 'Μαρία Κωνσταντίνου') {
      setClientName('Μαρία Κωνσταντίνου'); setClientAfm('987654321'); setClientDoy("Β' Αθηνών");
      setClientAddress('Πανεπιστημίου 25, 10679 Αθήνα'); setClientProfession('Ελεύθερη Επαγγελματίας');
    }
  };

  const handleSave = () => {
    if (!clientName || !clientAfm || items.length === 0) {
      alert('Συμπληρώστε Πελάτη, ΑΦΜ και τουλάχιστον ένα είδος');
      return;
    }
    const invoice = {
      type: invoiceType, series, number: series + '-' + number,
      issueDate, dueDate, paymentMethod,
      client: { name: clientName, afm: clientAfm, doy: clientDoy, address: clientAddress },
      items, calc, notes, sendMydata,
    };
    if (onSave) onSave(invoice);
    alert('Τιμολόγιο ' + series + '-' + number + ' αποθηκεύτηκε!' + (sendMydata ? '\nΑποστολή στο myDATA ΑΑΔΕ...' : ''));
    onClose();
  };

  const s = {
    label: { fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4, display: 'block' },
    input: { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, outline: 'none', boxSizing: 'border-box' },
    select: { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 13, outline: 'none', cursor: 'pointer', background: '#FFF', boxSizing: 'border-box' },
    card: { background: '#FFF', borderRadius: 12, border: '1px solid #E2E8F0', padding: 16, marginBottom: 12 },
    btn: { padding: '8px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer' },
    section: { fontSize: 14, fontWeight: 700, color: '#1E293B', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 },
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, display: 'flex' }} onClick={onClose}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }} />
      <div style={{
        position: 'relative', background: '#F8FAFC', width: '95%', maxWidth: 1000, height: '95vh',
        margin: 'auto', borderRadius: 16, display: 'flex', flexDirection: 'column',
        boxShadow: '0 25px 50px rgba(0,0,0,0.3)', overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>

        <div style={{ padding: '16px 24px', background: '#1E293B', color: '#FFF', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>Νέο Τιμολόγιο Παροχής Υπηρεσιών</h2>
            <p style={{ fontSize: 12, color: '#94A3B8', margin: '4px 0 0' }}>Αυτόματος υπολογισμός ΦΠΑ - Παρακράτηση - Χαρτόσημο - myDATA</p>
          </div>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#FFF', width: 36, height: 36, borderRadius: 8, fontSize: 18, cursor: 'pointer' }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: 24 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>

            <div>
              <div style={s.card}>
                <div style={s.section}>Στοιχεία Παραστατικού</div>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div>
                    <label style={s.label}>Τύπος</label>
                    <select value={invoiceType} onChange={e => setInvoiceType(e.target.value)} style={s.select}>
                      {INVOICE_TYPES.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={s.label}>Σειρά</label>
                    <input value={series} onChange={e => setSeries(e.target.value)} style={s.input} />
                  </div>
                  <div>
                    <label style={s.label}>Αριθμός</label>
                    <input value={number} onChange={e => setNumber(e.target.value)} style={s.input} />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
                  <div>
                    <label style={s.label}>Ημ/νία Έκδοσης</label>
                    <input type="date" value={issueDate} onChange={e => setIssueDate(e.target.value)} style={s.input} />
                  </div>
                  <div>
                    <label style={s.label}>Ημ/νία Λήξης</label>
                    <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} style={s.input} />
                  </div>
                  <div>
                    <label style={s.label}>Τρόπος Πληρωμής</label>
                    <select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} style={s.select}>
                      {PAYMENT_METHODS.map(m => <option key={m.id} value={m.id}>{m.icon} {m.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              <div style={s.card}>
                <div style={s.section}>Στοιχεία Πελάτη</div>
                <div style={{ marginBottom: 8 }}>
                  <label style={s.label}>Επιλογή Πελάτη</label>
                  <select value={selectedClient} onChange={e => handleSelectClient(e.target.value)} style={s.select}>
                    <option value="">-- Επιλέξτε --</option>
                    <option value="Γεώργιος Παπαδόπουλος">Γεώργιος Παπαδόπουλος</option>
                    <option value="Μαρία Κωνσταντίνου">Μαρία Κωνσταντίνου</option>
                    <option value="Δημήτρης Νικολάου">Δημήτρης Νικολάου</option>
                  </select>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <div>
                    <label style={s.label}>Ονοματεπώνυμο / Επωνυμία *</label>
                    <input value={clientName} onChange={e => setClientName(e.target.value)} style={s.input} />
                  </div>
                  <div>
                    <label style={s.label}>Επάγγελμα</label>
                    <input value={clientProfession} onChange={e => setClientProfession(e.target.value)} style={s.input} />
                  </div>
                  <div>
                    <label style={s.label}>ΑΦΜ *</label>
                    <input value={clientAfm} onChange={e => setClientAfm(e.target.value)} style={s.input} maxLength={9} />
                  </div>
                  <div>
                    <label style={s.label}>ΔΟΥ</label>
                    <select value={clientDoy} onChange={e => setClientDoy(e.target.value)} style={s.select}>
                      <option value="">Επιλέξτε...</option>
                      {DOY_LIST.map(d => <option key={d} value={d}>{d}</option>)}
                    </select>
                  </div>
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label style={s.label}>Διεύθυνση</label>
                    <input value={clientAddress} onChange={e => setClientAddress(e.target.value)} style={s.input} />
                  </div>
                </div>
              </div>

              <div style={s.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <div style={s.section}>Υπηρεσίες / Είδη</div>
                  <button onClick={addItem} style={{ ...s.btn, background: '#1E293B', color: '#FFF' }}>+ Προσθήκη</button>
                </div>
                {items.map((item, i) => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr auto', gap: 8, marginBottom: 8 }}>
                    <input value={item.description} onChange={e => updateItem(i, 'description', e.target.value)}
                      placeholder="Περιγραφή υπηρεσίας" style={s.input} />
                    <input type="number" value={item.qty} onChange={e => updateItem(i, 'qty', parseFloat(e.target.value) || 0)}
                      placeholder="Ποσ." style={s.input} />
                    <input type="number" value={item.amount} onChange={e => updateItem(i, 'amount', parseFloat(e.target.value) || 0)}
                      placeholder="Τιμή" style={s.input} />
                    {items.length > 1 && (
                      <button onClick={() => removeItem(i)} style={{ ...s.btn, background: '#FEF2F2', color: '#DC2626', padding: '8px 10px' }}>X</button>
                    )}
                  </div>
                ))}
              </div>

              <div style={s.card}>
                <div style={s.section}>Σημειώσεις & Τράπεζα</div>
                <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Σημειώσεις τιμολογίου..."
                  style={{ ...s.input, height: 50, resize: 'none', marginBottom: 8 }} />
                <label style={s.label}>Τραπεζικά Στοιχεία</label>
                <textarea value={bankInfo} onChange={e => setBankInfo(e.target.value)}
                  style={{ ...s.input, height: 50, resize: 'none', fontSize: 12 }} />
              </div>
            </div>

            <div>
              <div style={s.card}>
                <div style={s.section}>Φόροι & Κρατήσεις</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                    <input type="checkbox" checked={withFPA} onChange={e => setWithFPA(e.target.checked)} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>ΦΠΑ</span>
                    {withFPA && <select value={fpaRate} onChange={e => setFpaRate(parseInt(e.target.value))}
                      style={{ ...s.select, width: 80, padding: '4px 8px', fontSize: 12 }}>
                      <option value={24}>24%</option><option value={13}>13%</option><option value={6}>6%</option><option value={0}>0%</option>
                    </select>}
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                    <input type="checkbox" checked={withParakratisi} onChange={e => setWithParakratisi(e.target.checked)} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>Παρακράτηση Φόρου</span>
                    {withParakratisi && <select value={parakratisiRate} onChange={e => setParakratisiRate(parseInt(e.target.value))}
                      style={{ ...s.select, width: 80, padding: '4px 8px', fontSize: 12 }}>
                      <option value={15}>15%</option><option value={20}>20%</option><option value={0}>0%</option>
                    </select>}
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                    <input type="checkbox" checked={withXartosimo} onChange={e => setWithXartosimo(e.target.checked)} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>Χαρτόσημο + ΟΓΑ</span>
                    <span style={{ fontSize: 11, color: '#94A3B8' }}>(1.2% + 20% ΟΓΑ)</span>
                  </label>
                </div>
              </div>

              <div style={{ ...s.card, border: '2px solid #C7D2FE', background: '#EEF2FF' }}>
                <div style={s.section}>Γραμμάτιο Προείσπραξης ΔΣΑ</div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 10 }}>
                  <input type="checkbox" checked={withGrammatio} onChange={e => setWithGrammatio(e.target.checked)} />
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#312E81' }}>Υπολογισμός Γραμματίου</span>
                </label>
                {withGrammatio && (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    <div>
                      <label style={s.label}>Τύπος Ενέργειας</label>
                      <select value={grammatioType} onChange={e => setGrammatioType(e.target.value)} style={s.select}>
                        <option value="agogi">Κατάθεση Αγωγής</option>
                        <option value="parastasi">Παράσταση</option>
                      </select>
                    </div>
                    <div>
                      <label style={s.label}>Αξία Αντικειμένου</label>
                      <input type="number" value={streitwert} onChange={e => setStreitwert(parseFloat(e.target.value) || 0)} style={s.input} />
                    </div>
                    <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: 10, background: '#FFF', borderRadius: 8 }}>
                      <div style={{ fontSize: 11, color: '#64748B' }}>Ποσό Γραμματίου</div>
                      <div style={{ fontSize: 24, fontWeight: 800, color: '#4338CA' }}>{calc.grammatio.toFixed(2)} EUR</div>
                    </div>
                  </div>
                )}
              </div>

              <div style={{ ...s.card, background: '#1E293B', color: '#FFF' }}>
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Υπολογισμός</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13, color: '#CBD5E1' }}>
                  <span>Καθαρή Αξία</span><span>{calc.subtotal.toFixed(2)} EUR</span>
                </div>
                {withFPA && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13, color: '#CBD5E1' }}>
                    <span>ΦΠΑ {fpaRate}%</span><span>{calc.fpa.toFixed(2)} EUR</span>
                  </div>
                )}
                {withXartosimo && (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13, color: '#CBD5E1' }}>
                      <span>Χαρτόσημο {xartosimoRate}%</span><span>{calc.xartosimo.toFixed(2)} EUR</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13, color: '#CBD5E1' }}>
                      <span>ΟΓΑ Χαρτοσήμου 20%</span><span>{calc.ogaXartosimo.toFixed(2)} EUR</span>
                    </div>
                  </>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', marginTop: 4, borderTop: '1px solid #334155', fontSize: 15, fontWeight: 700 }}>
                  <span>Σύνολο</span><span>{calc.total.toFixed(2)} EUR</span>
                </div>
                {withParakratisi && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 13, color: '#F87171' }}>
                    <span>Παρακράτηση Φόρου {parakratisiRate}%</span><span>-{calc.parakratisi.toFixed(2)} EUR</span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', marginTop: 4, borderTop: '2px solid #10B981', fontSize: 20, fontWeight: 800, color: '#10B981' }}>
                  <span>Πληρωτέο</span><span>{calc.pliroteo.toFixed(2)} EUR</span>
                </div>
                {withGrammatio && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: 12, color: '#A78BFA' }}>
                    <span>+ Γραμμάτιο ΔΣΑ</span><span>{calc.grammatio.toFixed(2)} EUR</span>
                  </div>
                )}
              </div>

              <div style={{ ...s.card, border: '2px solid #3B82F6', background: '#EFF6FF' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 24 }}>📡</span>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1E40AF' }}>ΑΑΔΕ myDATA</div>
                      <div style={{ fontSize: 11, color: '#3B82F6' }}>Αυτόματη αποστολή παραστατικού</div>
                    </div>
                  </div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                    <input type="checkbox" checked={sendMydata} onChange={e => setSendMydata(e.target.checked)} style={{ width: 18, height: 18 }} />
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#1E40AF' }}>{sendMydata ? 'Ενεργό' : 'Ανενεργό'}</span>
                  </label>
                </div>
                {sendMydata && (
                  <div style={{ marginTop: 8, padding: 8, background: '#FFF', borderRadius: 6, fontSize: 11, color: '#64748B' }}>
                    Τύπος: {(INVOICE_TYPES.find(function(t) { return t.id === invoiceType; }) || {}).mydata || '2.1'} | ΜΑΡΚ: θα εκδοθεί αυτόματα | Κατηγορία: Παροχή Υπηρεσιών
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div style={{ padding: '12px 24px', background: '#FFF', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ ...s.btn, background: '#F1F5F9', color: '#475569' }}>Προεπισκόπηση</button>
            <button style={{ ...s.btn, background: '#EFF6FF', color: '#2563EB' }}>Εκτύπωση</button>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={onClose} style={{ ...s.btn, background: '#F1F5F9', color: '#475569', border: '1px solid #E2E8F0' }}>Ακύρωση</button>
            <button onClick={handleSave} style={{ ...s.btn, background: '#1E293B', color: '#FFF', padding: '10px 24px', fontSize: 14 }}>
              {sendMydata ? 'Έκδοση & Αποστολή myDATA' : 'Έκδοση Τιμολογίου'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceCreator;
